// extracted by mini-css-extract-plugin
export default {"stats":"styles_stats__-KInw","stats__block":"styles_stats__block__91Qyw","stats__block-card":"styles_stats__block-card__L-yrX"};